import React, { Fragment, useEffect } from "react";
import NewNavbar from "../../new-components/NewNavbar";
import NewOverrides from "../../new-components/NewOverrides";
import NewDesignSystem from "../../new-components/NewDesignSystem";
import NewPageHeader from "../../new-components/NewPageHeader";
import CampaignSingle from "../../components/CampaignDetails";
import NewFooter from "../../new-components/NewFooter";
import NewMadeWith from "../../new-components/NewMadeWith";
import NewScrollTop from "../../new-components/NewScrollTop";
import NewBackButton from "../../new-components/NewBackButton";
import "../EventDetailsFull/style.css";

const Events = ({ campaignId }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />
      <NewPageHeader />
      <main className="registration-page samples-registration-page">
        <CampaignSingle
          campaignId={campaignId}
          blLeft={"d-none"}
          blRight={"col-lg-10 offset-lg-1"}
        />
      </main>
      <NewBackButton />
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};
export default Events;
